import React, { Component } from "react"
import emailjs from "@emailjs/browser"

const EMAILJS_CONFIG = {
  serviceId: "service_5lmx4ll",
  templateId: "template_2lgo4uq",
  publicKey: "SgZflZRhQWTK8QfeY",
  toEmail: "soumya@param.ai",
}

const SHAFT_CSS = `
    :root {
      --panel: #ffffff;
      --panel-soft: #f8fbff;
      --ink: #0f172a;
      --muted: #64748b;
      --line: #d8e2ee;
      --accent: #0f766e;
      --accent-dark: #0b5e58;
      --navy: #0b1f3a;
      --navy-2: #1f4b87;
      --danger: #b42318;
      --warning-bg: #fff7ed;
      --warning-line: #fdba74;
      --warning-ink: #9a3412;
      --success: #166534;
      --shadow: 0 20px 48px rgba(15, 23, 42, 0.10);
      --radius-xl: 28px;
      --radius-md: 14px;
    }
.shaft-estimator-wrapper * { box-sizing: border-box; }

    .shaft-estimator-wrapper {
      margin: 0;
      font-family: Inter, Arial, Helvetica, sans-serif;
      color: var(--ink);
      background:
        radial-gradient(circle at top left, rgba(15,118,110,0.08), transparent 28%),
        linear-gradient(180deg, #eef3f9 0%, #f8fbfd 100%);
      border-radius: var(--radius-xl);
      overflow: hidden;
    }

    .shaft-estimator-wrapper .page {
      max-width: 1240px;
      margin: 0 auto;
      padding: 32px 20px 56px;
    }
.shaft-estimator-wrapper .hero {
      position: relative;
      overflow: hidden;
      background: linear-gradient(135deg, var(--navy) 0%, #12335d 55%, var(--navy-2) 100%);
      color: #fff;
      border-radius: var(--radius-xl);
      padding: 38px 40px;
      box-shadow: var(--shadow);
      margin-bottom: 24px;
    }
.shaft-estimator-wrapper .hero::before,
.shaft-estimator-wrapper .hero::after {
      content: "";
      position: absolute;
      border-radius: 999px;
      background: rgba(255,255,255,0.08);
    }
.shaft-estimator-wrapper .hero::before {
      width: 240px;
      height: 240px;
      top: -90px;
      right: -70px;
    }
.shaft-estimator-wrapper .hero::after {
      width: 140px;
      height: 140px;
      bottom: -40px;
      right: 140px;
    }
.shaft-estimator-wrapper .eyebrow {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 8px 12px;
      border-radius: 999px;
      background: rgba(255,255,255,0.12);
      font-size: 12px;
      font-weight: 700;
      letter-spacing: .08em;
      text-transform: uppercase;
      margin-bottom: 14px;
    }
.shaft-estimator-wrapper h1 {
      margin: 0 0 10px;
      font-size: 36px;
      line-height: 1.08;
      letter-spacing: -0.02em;
    }
.shaft-estimator-wrapper .hero p {
      margin: 0;
      max-width: 760px;
      color: rgba(255,255,255,0.88);
      line-height: 1.65;
      font-size: 16px;
    }
.shaft-estimator-wrapper .layout {
      display: grid;
      grid-template-columns: minmax(0, 1.15fr) 360px;
      gap: 24px;
      align-items: start;
    }
.shaft-estimator-wrapper .card {
      background: var(--panel);
      border: 1px solid rgba(15, 23, 42, 0.06);
      border-radius: var(--radius-xl);
      box-shadow: var(--shadow);
    }
.shaft-estimator-wrapper .form-shell {
      padding: 30px;
    }
.shaft-estimator-wrapper .sidebar {
      padding: 28px;
      position: sticky;
      top: 20px;
    }
.shaft-estimator-wrapper .section-title {
      margin: 0 0 8px;
      font-size: 22px;
      line-height: 1.2;
    }
.shaft-estimator-wrapper .section-copy {
      margin: 0 0 18px;
      color: var(--muted);
      font-size: 14px;
      line-height: 1.6;
    }
.shaft-estimator-wrapper .soft-panel {
      background: var(--panel-soft);
      border: 1px solid #e8eef5;
      border-radius: 22px;
      padding: 20px;
    }
.shaft-estimator-wrapper .grid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 18px;
    }
.shaft-estimator-wrapper .field {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
.shaft-estimator-wrapper .field.full {
      grid-column: 1 / -1;
    }
.shaft-estimator-wrapper label {
      font-size: 13px;
      font-weight: 700;
      color: #334155;
    }
.shaft-estimator-wrapper input, .shaft-estimator-wrapper select {
      width: 100%;
      border: 1px solid var(--line);
      background: #fff;
      border-radius: var(--radius-md);
      min-height: 52px;
      padding: 13px 14px;
      font-size: 15px;
      color: var(--ink);
      outline: none;
      transition: border-color .18s ease, box-shadow .18s ease, transform .18s ease;
    }
.shaft-estimator-wrapper input:focus, .shaft-estimator-wrapper select:focus {
      border-color: rgba(15,118,110,0.7);
      box-shadow: 0 0 0 4px rgba(15,118,110,0.12);
      transform: translateY(-1px);
    }
.shaft-estimator-wrapper .hint {
      color: var(--muted);
      font-size: 12px;
      line-height: 1.5;
      margin-top: -2px;
    }
.shaft-estimator-wrapper .warning-box {
      display: none;
      margin-top: 6px;
      padding: 14px 16px;
      border-radius: 14px;
      background: var(--warning-bg);
      border: 1px solid var(--warning-line);
      color: var(--warning-ink);
      font-size: 12px;
      line-height: 1.6;
      font-weight: 600;
    }
.shaft-estimator-wrapper .warning-box.active {
      display: block;
    }
.shaft-estimator-wrapper .actions {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
      margin-top: 24px;
    }
.shaft-estimator-wrapper button {
      border: 0;
      min-height: 52px;
      padding: 0 20px;
      border-radius: 14px;
      font-size: 14px;
      font-weight: 700;
      cursor: pointer;
      transition: transform .15s ease, opacity .15s ease, background .18s ease;
    }
.shaft-estimator-wrapper button:hover { transform: translateY(-1px); }
.shaft-estimator-wrapper .primary {
      background: linear-gradient(135deg, var(--accent) 0%, var(--accent-dark) 100%);
      color: #fff;
      min-width: 190px;
    }
.shaft-estimator-wrapper .secondary {
      background: #eff4fa;
      color: #1e293b;
      min-width: 140px;
    }
.shaft-estimator-wrapper .badge {
      display: inline-flex;
      align-items: center;
      padding: 8px 12px;
      border-radius: 999px;
      background: #e8f7f4;
      color: var(--accent-dark);
      font-size: 12px;
      font-weight: 700;
      margin-bottom: 14px;
    }
.shaft-estimator-wrapper .summary {
      display: grid;
      gap: 12px;
      margin-top: 18px;
    }
.shaft-estimator-wrapper .summary-row {
      display: flex;
      justify-content: space-between;
      gap: 16px;
      align-items: center;
      padding: 14px 16px;
      background: #f8fafc;
      border: 1px solid #edf2f7;
      border-radius: 14px;
    }
.shaft-estimator-wrapper .summary-row strong { font-size: 14px; }
.shaft-estimator-wrapper .summary-row span { font-size: 15px; font-weight: 700; }
.shaft-estimator-wrapper .summary-row.total {
      background: linear-gradient(180deg, #edfdf8 0%, #e0f7f1 100%);
      border-color: rgba(15,118,110,.18);
    }
.shaft-estimator-wrapper .summary-row.total strong,
.shaft-estimator-wrapper .summary-row.total span {
      font-size: 18px;
    }
.shaft-estimator-wrapper .kpis {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 12px;
      margin-top: 18px;
    }
.shaft-estimator-wrapper .kpi {
      background: #f8fafc;
      border: 1px solid #edf2f7;
      border-radius: 14px;
      padding: 14px;
    }
.shaft-estimator-wrapper .kpi-label {
      color: var(--muted);
      font-size: 12px;
      margin-bottom: 6px;
    }
.shaft-estimator-wrapper .kpi-value {
      font-size: 16px;
      font-weight: 800;
      color: #0f172a;
    }
.shaft-estimator-wrapper .status {
      display: none;
      margin-top: 18px;
      padding: 14px 16px;
      border-radius: 14px;
      font-size: 13px;
      line-height: 1.6;
      border: 1px solid transparent;
    }
.shaft-estimator-wrapper .status.success {
      display: block;
      background: #ecfdf3;
      border-color: #bbf7d0;
      color: var(--success);
    }
.shaft-estimator-wrapper .status.error {
      display: block;
      background: #fff1f2;
      border-color: #fecdd3;
      color: var(--danger);
    }
.shaft-estimator-wrapper .info-list {
      display: grid;
      gap: 12px;
      margin-top: 18px;
    }
.shaft-estimator-wrapper .info-item {
      padding: 14px 15px;
      border-radius: 16px;
      background: #f8fafc;
      border: 1px solid #e8eef5;
    }
.shaft-estimator-wrapper .info-item strong {
      display: block;
      font-size: 13px;
      margin-bottom: 5px;
      color: #0f172a;
    }
.shaft-estimator-wrapper .info-item span {
      color: var(--muted);
      font-size: 13px;
      line-height: 1.55;
    }
.shaft-estimator-wrapper .footnote-list {
      display: grid;
      gap: 12px;
      margin-top: 22px;
    }
.shaft-estimator-wrapper .footnote {
      padding: 14px 16px;
      border-radius: 14px;
      background: #f8fafc;
      border: 1px solid #e7eef7;
      color: #334155;
      font-size: 12px;
      line-height: 1.65;
    }
.shaft-estimator-wrapper .footnote strong {
      color: #0f172a;
    }
.shaft-estimator-wrapper .fine-print {
      margin-top: 18px;
      color: var(--muted);
      font-size: 12px;
      line-height: 1.7;
    }
    .shaft-estimator-wrapper .email-section {
      margin-top: 28px;
      padding-top: 24px;
      border-top: 1px solid var(--line);
    }
    .shaft-estimator-wrapper .email-section h3 {
      margin: 0 0 6px;
      font-size: 18px;
    }
    .shaft-estimator-wrapper .email-section .section-copy {
      margin-bottom: 16px;
    }
    .shaft-estimator-wrapper .email-grid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 16px;
      margin-bottom: 16px;
    }
    .shaft-estimator-wrapper .email-grid .field.full {
      grid-column: 1 / -1;
    }
    .shaft-estimator-wrapper .email-grid input {
      min-height: 46px;
      padding: 11px 14px;
    }

    @media (max-width: 980px) {
      .shaft-estimator-wrapper .layout { grid-template-columns: 1fr; }
      .shaft-estimator-wrapper .sidebar { position: static; }
    }

    @media (max-width: 720px) {
      .shaft-estimator-wrapper .page { padding: 20px 14px 40px; }
      .shaft-estimator-wrapper .hero, .shaft-estimator-wrapper .form-shell, .shaft-estimator-wrapper .sidebar { padding: 24px 20px; }
      .shaft-estimator-wrapper .grid, .shaft-estimator-wrapper .kpis { grid-template-columns: 1fr; }
      .shaft-estimator-wrapper h1 { font-size: 30px; }
    }
  `

const SHAFT_HTML = `<div class="page">
    <section class="hero">
      <div class="eyebrow">Marine Shaft Pricing</div>
      <h1>Propeller Shaft Price Estimator</h1>
    </section>

    <div class="layout">
      <section class="card form-shell">
        <h2 class="section-title">Configure Your Shaft</h2>
        <p class="section-copy">Enter the shaft details below. Single taper is treated as the standard configuration. Additional machining and coupling services are added based on the selections made.</p>

        <div class="soft-panel">
          <div class="grid">
            <div class="field">
              <label for="material">Material Grade</label>
              <select id="material"></select>
            </div>

            <div class="field">
              <label for="diameter">Shaft Diameter</label>
              <select id="diameter"></select>
            </div>

            <div class="field">
              <label for="length">Shaft Length (inches)</label>
              <input id="length" type="number" min="24" max="264" step="1" value="41" />
              <div class="hint">Pricing rounds up to the next full foot.</div>
            </div>

            <div class="field">
              <label for="taper">Taper Configuration</label>
              <select id="taper">
                <option value="Single Taper">Single Taper</option>
                <option value="Double Taper">Double Taper</option>
              </select>
            </div>

            <div class="field">
              <label for="coupling">Fit and Face Coupling</label>
              <select id="coupling">
                <option value="New">Fit and Face Coupling - New</option>
                <option value="Existing">Fit and Face Coupling - Existing</option>
                <option value="Decline">Decline to Fit and Face Coupling</option>
              </select>
              <div id="declineWarning" class="warning-box">
                Warning: By declining fit and face coupling service, the customer accepts responsibility for final fitment, face condition, and alignment of the coupling. General Propeller is not responsible for issues arising from customer-supplied or unmachined coupling surfaces when this option is declined.
              </div>
            </div>

          </div>
        </div>

        <div class="actions">
          <button class="primary" id="calculateBtn" type="button">Calculate Price</button>
          <button class="secondary" id="resetBtn" type="button">Reset Form</button>
        </div>

        <div id="calcStatus" class="status"></div>

        <div class="email-section">
          <h3 class="section-title">Request a Quote</h3>
          <p class="section-copy">Send your configuration to our sales team for a formal quote and ordering.</p>
          <div class="email-grid soft-panel">
            <div class="field">
              <label for="customerName">Your Name</label>
              <input id="customerName" type="text" placeholder="Full name" />
            </div>
            <div class="field">
              <label for="customerEmail">Email Address</label>
              <input id="customerEmail" type="email" placeholder="you@company.com" />
            </div>
            <div class="field full">
              <label for="customerPhone">Phone (optional)</label>
              <input id="customerPhone" type="tel" placeholder="(555) 123-4567" />
            </div>
            <div class="field full">
              <label for="customerNotes">Notes / Questions</label>
              <input id="customerNotes" type="text" placeholder="Any special requirements..." />
            </div>
          </div>
          <div class="actions">
            <button class="primary" id="emailQuoteBtn" type="button">Email Quote Request</button>
          </div>
          <div id="emailStatus" class="status"></div>
        </div>

      </section>

      <aside class="card sidebar">
        <h2 class="section-title">Price Summary</h2>

        <div class="summary">
          <div class="summary-row">
            <strong>Configured Shaft Price</strong>
            <span id="basePrice">\$0.00</span>
          </div>
          <div class="summary-row">
            <strong>Taper &amp; Coupling Services</strong>
            <span id="servicePrice">\$0.00</span>
          </div>
          <div class="summary-row total">
            <strong>Estimated Price</strong>
            <span id="totalPrice">\$0.00</span>
          </div>
        </div>

        <div class="kpis">
          <div class="kpi">
            <div class="kpi-label">Billable Length</div>
            <div class="kpi-value" id="billableLength">4 ft</div>
          </div>
          <div class="kpi">
            <div class="kpi-label">Diameter</div>
            <div class="kpi-value" id="selectedDiameter">1.000 in</div>
          </div>
          <div class="kpi">
            <div class="kpi-label">End Configuration</div>
            <div class="kpi-value" id="selectedConfig">Single / New</div>
          </div>
        </div>

        <div class="footnote-list">
          <div class="footnote"><strong>Wholesalers:</strong> Please reach out regarding commercial discounts.</div>
          <div class="footnote"><strong>Order Approval Requirement:</strong> All shafting orders require a follow-up phone call and an approval email to proceed. If we do not hear back from the customer within 24 hours on a business day, the order will be refunded.</div>
        </div>
      </aside>
    </div>
  </div>`

class ShaftPriceEstimator extends Component {
  componentDidMount() {
    const styleEl = document.createElement("style")
    styleEl.setAttribute("data-shaft-estimator", "true")
    styleEl.textContent = SHAFT_CSS
    document.head.appendChild(styleEl)

    this.initPricing()
  }

  componentWillUnmount() {
    const styleEl = document.querySelector('style[data-shaft-estimator]')
    if (styleEl) styleEl.remove()
  }

  initPricing() {
    const PRICING = {"AQ17":{"material":"AQ17","diameters":["0.75","0.875","1","1.125","1.25","1.375","1.5","1.75","2","2.25","2.5","2.75","3"],"length_prices":{"2":{"0.75":null,"0.875":null,"1":218.09199999999998,"1.125":259.44315277777775,"1.25":348.64930555555554,"1.375":401.9301388888889,"1.5":488.1572222222223,"1.75":634.1199166666665,"2":831.0355555555556,"2.25":1025.0276388888888,"2.5":1219.4055555555556,"2.75":1515.7745277777778,"3":1880.6186666666667},"3":{"0.75":null,"0.875":null,"1":269.09134210526315,"1.125":324.8043575475146,"1.25":438.3995111476608,"1.375":514.8452293494153,"1.5":620.559360380117,"1.75":813.2580334429823,"2":1061.7329239766082,"2.25":1317.0039957967833,"2.5":1578.7723318713452,"2.75":1944.8518715277778,"3":2388.621298245614},"4":{"0.75":null,"0.875":null,"1":320.0906842105263,"1.125":390.16556231725144,"1.25":528.1497167397661,"1.375":627.7603198099416,"1.5":752.9614985380117,"1.75":992.3961502192981,"2":1292.4302923976609,"2.25":1608.980352704678,"2.5":1938.1391081871348,"2.75":2373.929215277778,"3":2896.6239298245614},"5":{"0.75":null,"0.875":null,"1":371.0900263157895,"1.125":455.5267670869883,"1.25":617.8999223318713,"1.375":740.675410270468,"1.5":885.3636366959065,"1.75":1171.534266995614,"2":1523.1276608187136,"2.25":1900.9567096125725,"2.5":2297.5058845029243,"2.75":2803.006559027778,"3":3404.6265614035087},"6":{"0.75":null,"0.875":null,"1":422.08936842105265,"1.125":520.8879718567251,"1.25":707.6501279239765,"1.375":853.5905007309943,"1.5":1017.7657748538013,"1.75":1350.6723837719296,"2":1753.8250292397663,"2.25":2192.933066520467,"2.5":2656.872660818714,"2.75":3232.0839027777783,"3":3912.629192982456},"7":{"0.75":null,"0.875":null,"1":473.0887105263158,"1.125":586.249176626462,"1.25":797.4003335160817,"1.375":966.5055911915207,"1.5":1150.167913011696,"1.75":1529.8105005482453,"2":1984.522397660819,"2.25":2484.9094234283616,"2.5":3016.2394371345035,"2.75":3661.1612465277785,"3":4420.631824561404},"8":{"0.75":null,"0.875":null,"1":524.088052631579,"1.125":651.6103813961988,"1.25":887.1505391081869,"1.375":1079.420681652047,"1.5":1282.570051169591,"1.75":1708.948617324561,"2":2215.2197660818715,"2.25":2776.885780336256,"2.5":3375.606213450293,"2.75":4090.2385902777787,"3":4928.634456140351},"9":{"0.75":null,"0.875":null,"1":575.0873947368422,"1.125":716.9715861659356,"1.25":976.9007447002921,"1.375":1192.3357721125733,"1.5":1414.9721893274857,"1.75":1888.0867341008766,"2":2445.917134502924,"2.25":3068.8621372441507,"2.5":3734.9729897660827,"2.75":4519.315934027779,"3":5436.6370877192985},"10":{"0.75":null,"0.875":null,"1":626.0867368421053,"1.125":782.3327909356724,"1.25":1066.6509502923973,"1.375":1305.2508625730995,"1.5":1547.3743274853805,"1.75":2067.2248508771922,"2":2676.6145029239765,"2.25":3360.8384941520453,"2.5":4094.3397660818723,"2.75":4948.393277777779,"3":5944.639719298246},"11":{"0.75":null,"0.875":null,"1":677.0860789473685,"1.125":847.6939957054092,"1.25":1156.4011558845025,"1.375":1418.1659530336258,"1.5":1679.7764656432753,"1.75":2246.362967653508,"2":2907.311871345029,"2.25":3652.81485105994,"2.5":4453.706542397662,"2.75":5377.470621527779,"3":6452.642350877193},"12":{"0.75":null,"0.875":null,"1":728.0854210526317,"1.125":913.055200475146,"1.25":1246.1513614766077,"1.375":1531.081043494152,"1.5":1812.17860380117,"1.75":2425.5010844298235,"2":3138.0092397660815,"2.25":3944.7912079678345,"2.5":4813.073318713451,"2.75":5806.547965277779,"3":6960.6449824561405},"13":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":690.2678846153846,"1.375":808.3571826923076,"1.5":1944.5807419590649,"1.75":2604.639201206139,"2":3368.706608187134,"2.25":4236.7675648757295,"2.5":5172.44009502924,"2.75":6235.62530902778,"3":7468.647614035088},"14":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":730.745769230769,"1.375":857.128326923077,"1.5":2076.9828801169597,"1.75":2783.777317982455,"2":3599.4039766081864,"2.25":4528.7439217836245,"2.5":5531.806871345029,"2.75":6664.70265277778,"3":7976.650245614035},"15":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":905.8994711538462,"1.5":2209.3850182748542,"1.75":2962.9154347587705,"2":3830.101345029239,"2.25":4820.7202786915195,"2.5":5891.1736476608185,"2.75":7093.77999652778,"3":8484.652877192982},"16":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":954.6706153846153,"1.5":2341.787156432749,"1.75":3142.053551535086,"2":4060.7987134502914,"2.25":5112.696635599415,"2.5":6250.540423976608,"2.75":7522.85734027778,"3":8992.65550877193},"17":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":2474.1892945906434,"1.75":3321.191668311402,"2":4291.496081871344,"2.25":5404.67299250731,"2.5":6609.907200292397,"2.75":7951.93468402778,"3":9500.658140350877},"18":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":2606.591432748538,"1.75":3500.3297850877175,"2":4522.193450292397,"2.25":5696.649349415205,"2.5":6969.273976608186,"2.75":8381.01202777778,"3":10008.660771929824},"19":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":2738.9935709064325,"1.75":3679.467901864033,"2":4752.890818713449,"2.25":5988.6257063231,"2.5":7328.640752923975,"2.75":8810.08937152778,"3":10516.663403508772},"20":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":2871.395709064327,"1.75":3858.606018640349,"2":4983.588187134502,"2.25":6280.602063230995,"2.5":7688.007529239764,"2.75":9239.166715277779,"3":11024.66603508772},"21":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":null,"1.75":null,"2":5214.285555555554,"2.25":6572.57842013889,"2.5":8047.374305555553,"2.75":9668.244059027778,"3":11532.668666666666},"22":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":null,"1.75":null,"2":5444.982923976607,"2.25":6864.554777046785,"2.5":8406.741081871343,"2.75":10097.321402777778,"3":12040.671298245614}},"fit_prices":{"New Fit":{"0.75":51.0,"0.875":51.0,"1":51.0,"1.125":51.0,"1.25":55.0,"1.375":55.0,"1.5":63.0,"1.75":63.0,"2":69.0,"2.25":78.0,"2.5":78.0,"2.75":90.0,"3":97.0},"Customer-Supplied Fit":{"0.75":67.0,"0.875":67.0,"1":67.0,"1.125":67.0,"1.25":72.0,"1.375":72.0,"1.5":78.0,"1.75":78.0,"2":90.0,"2.25":101.0,"2.5":101.0,"2.75":117.0,"3":124.0},"Double Taper":{"0.75":85.0,"0.875":85.0,"1":85.0,"1.125":85.0,"1.25":104.0,"1.375":104.0,"1.5":121.0,"1.75":127.0,"2":173.0,"2.25":253.0,"2.5":276.0,"2.75":322.0,"3":391.0}}},"AQ19":{"material":"AQ19","diameters":["0.75","0.875","1","1.125","1.25","1.375","1.5","1.75","2","2.25","2.5","2.75","3"],"length_prices":{"2":{"0.75":null,"0.875":null,"1":256.54,"1.125":306.90240277777775,"1.25":377.9451388888889,"1.375":424.5899097222222,"1.5":518.3282222222223,"1.75":674.8225833333333,"2":883.7235555555555,"2.25":1093.513138888889,"2.5":1286.8972222222224,"2.75":1609.1058611111112,"3":1991.6906666666666},"3":{"0.75":null,"0.875":null,"1":326.5103947368421,"1.125":395.68100063961987,"1.25":482.1505254020468,"1.375":548.6858081597222,"1.5":665.6173669590644,"1.75":874.0442527412281,"2":1140.418292397661,"2.25":1419.2816832967837,"2.5":1679.5658077485382,"2.75":2084.234849597953,"3":2554.4985614035086},"4":{"0.75":null,"0.875":null,"1":396.4807894736842,"1.125":484.459598501462,"1.25":586.3559119152047,"1.375":672.7817065972222,"1.5":812.9065116959065,"1.75":1073.2659221491228,"2":1397.113029239766,"2.25":1745.0502277046785,"2.5":2072.234393274854,"2.75":2559.363838084795,"3":3117.3064561403507},"5":{"0.75":null,"0.875":null,"1":466.45118421052626,"1.125":573.238196363304,"1.25":690.5612984283626,"1.375":796.8776050347221,"1.5":960.1956564327486,"1.75":1272.4875915570176,"2":1653.8077660818713,"2.25":2070.8187721125732,"2.5":2464.90297880117,"2.75":3034.492826571637,"3":3680.114350877193},"6":{"0.75":null,"0.875":null,"1":536.4215789473684,"1.125":662.0167942251461,"1.25":794.7666849415206,"1.375":920.9735034722221,"1.5":1107.4848011695908,"1.75":1471.7092609649123,"2":1910.5025029239764,"2.25":2396.587316520468,"2.5":2857.5715643274857,"2.75":3509.621815058479,"3":4242.922245614035},"7":{"0.75":null,"0.875":null,"1":606.3919736842105,"1.125":750.7953920869882,"1.25":898.9720714546785,"1.375":1045.069401909722,"1.5":1254.7739459064328,"1.75":1670.930930372807,"2":2167.1972397660816,"2.25":2722.3558609283627,"2.5":3250.2401498538015,"2.75":3984.750803545321,"3":4805.730140350877},"8":{"0.75":null,"0.875":null,"1":676.3623684210526,"1.125":839.5739899488302,"1.25":1003.1774579678364,"1.375":1169.165300347222,"1.5":1402.0630906432748,"1.75":1870.1525997807018,"2":2423.8919766081867,"2.25":3048.1244053362575,"2.5":3642.9087353801174,"2.75":4459.879792032163,"3":5368.538035087719},"9":{"0.75":null,"0.875":null,"1":746.3327631578946,"1.125":928.3525878106723,"1.25":1107.3828444809942,"1.375":1293.261198784722,"1.5":1549.3522353801168,"1.75":2069.3742691885964,"2":2680.586713450292,"2.25":3373.8929497441522,"2.5":4035.577320906433,"2.75":4935.008780519005,"3":5931.345929824562},"10":{"0.75":null,"0.875":null,"1":816.3031578947367,"1.125":1017.1311856725143,"1.25":1211.5882309941521,"1.375":1417.357097222222,"1.5":1696.6413801169588,"1.75":2268.595938596491,"2":2937.281450292397,"2.25":3699.661494152047,"2.5":4428.245906432749,"2.75":5410.137769005847,"3":6494.153824561404},"11":{"0.75":null,"0.875":null,"1":886.2735526315788,"1.125":1105.9097835343564,"1.25":1315.79361750731,"1.375":1541.4529956597219,"1.5":1843.9305248538008,"1.75":2467.817608004386,"2":3193.976187134502,"2.25":4025.4300385599417,"2.5":4820.914491959064,"2.75":5885.266757492689,"3":7056.961719298246},"12":{"0.75":null,"0.875":null,"1":956.2439473684209,"1.125":1194.6883813961986,"1.25":1419.999004020468,"1.375":1665.5488940972218,"1.5":1991.2196695906428,"1.75":2667.0392774122806,"2":3450.6709239766074,"2.25":4351.198582967836,"2.5":5213.58307748538,"2.75":6360.395745979531,"3":7619.769614035088},"13":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":1524.2043905336259,"1.375":1789.6447925347218,"1.5":2138.5088143274847,"1.75":2866.2609468201754,"2":3707.3656608187125,"2.25":4676.96712737573,"2.5":5606.251663011696,"2.75":6835.524734466373,"3":8182.57750877193},"14":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":1628.4097770467838,"1.375":1913.7406909722217,"1.5":2285.7979590643267,"1.75":3065.48261622807,"2":3964.0603976608177,"2.25":5002.735671783625,"2.5":5998.920248538012,"2.75":7310.653722953215,"3":8745.385403508772},"15":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":2037.8365894097217,"1.5":2433.0871038011687,"1.75":3264.704285635965,"2":4220.755134502923,"2.25":5328.504216191519,"2.5":6391.588834064328,"2.75":7785.782711440057,"3":9308.193298245613},"16":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":2161.9324878472216,"1.5":2580.3762485380107,"1.75":3463.9259550438596,"2":4477.449871345028,"2.25":5654.272760599413,"2.5":6784.257419590644,"2.75":8260.911699926899,"3":9871.001192982454},"17":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":2727.6653932748527,"1.75":3663.1476244517544,"2":4734.144608187134,"2.25":5980.0413050073075,"2.5":7176.9260051169595,"2.75":8736.040688413741,"3":10433.809087719295},"18":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":2874.9545380116947,"1.75":3862.369293859649,"2":4990.839345029239,"2.25":6305.809849415202,"2.5":7569.594590643275,"2.75":9211.169676900583,"3":10996.616982456137},"19":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":3022.2436827485367,"1.75":4061.590963267544,"2":5247.534081871344,"2.25":6631.578393823096,"2.5":7962.263176169591,"2.75":9686.298665387425,"3":11559.424877192978},"20":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":3169.5328274853787,"1.75":4260.812632675438,"2":5504.228818713449,"2.25":6957.34693823099,"2.5":8354.931761695907,"2.75":10161.427653874267,"3":12122.23277192982},"21":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":null,"1.75":null,"2":5760.923555555554,"2.25":7283.115482638885,"2.5":8747.600347222222,"2.75":10636.556642361109,"3":12685.04066666666},"22":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":null,"1.75":null,"2":6017.618292397659,"2.25":7608.884027046779,"2.5":9140.268932748539,"2.75":11111.685630847951,"3":13247.848561403502}},"fit_prices":{"New Fit":{"0.75":51.0,"0.875":51.0,"1":51.0,"1.125":51.0,"1.25":55.0,"1.375":55.0,"1.5":63.0,"1.75":63.0,"2":69.0,"2.25":78.0,"2.5":78.0,"2.75":90.0,"3":97.0},"Customer-Supplied Fit":{"0.75":67.0,"0.875":67.0,"1":67.0,"1.125":67.0,"1.25":72.0,"1.375":72.0,"1.5":78.0,"1.75":78.0,"2":90.0,"2.25":101.0,"2.5":101.0,"2.75":117.0,"3":124.0},"Double Taper":{"0.75":85.0,"0.875":85.0,"1":85.0,"1.125":85.0,"1.25":104.0,"1.375":104.0,"1.5":121.0,"1.75":127.0,"2":173.0,"2.25":253.0,"2.5":276.0,"2.75":322.0,"3":391.0}}},"AQ22":{"material":"AQ22","diameters":["0.75","0.875","1","1.125","1.25","1.375","1.5","1.75","2","2.25","2.5","2.75","3"],"length_prices":{"2":{"0.75":219.29541666666668,"0.875":266.80674305555556,"1":344.472,"1.125":413.2351527777778,"1.25":519.0472222222222,"1.375":602.5027638888889,"1.5":732.4622222222222,"1.75":967.3729999999999,"2":1267.7288888888888,"2.25":1575.9153888888889,"2.5":1900.2555555555555,"2.75":2335.1159444444443,"3":2849.2946666666676},"3":{"0.75":284.20979166666666,"0.875":354.79900347222224,"1":459.3413333333333,"1.125":556.3638402777777,"1.25":695.1930555555556,"1.375":817.2097013888889,"1.5":988.7822222222221,"1.75":1315.5261666666665,"2":1719.8488888888887,"2.25":2147.228638888889,"2.5":2604.838888888889,"2.75":3179.5850277777777,"3":3848.4086666666676},"4":{"0.75":349.12416666666667,"0.875":442.7912638888889,"1":574.2106666666666,"1.125":699.4925277777777,"1.25":871.338888888889,"1.375":1031.9166388888889,"1.5":1245.102222222222,"1.75":1663.679333333333,"2":2171.9688888888886,"2.25":2718.541888888889,"2.5":3309.4222222222224,"2.75":4024.054111111111,"3":4847.522666666668},"5":{"0.75":414.0385416666667,"0.875":530.7835243055556,"1":689.0799999999999,"1.125":842.6212152777777,"1.25":1047.4847222222222,"1.375":1246.623576388889,"1.5":1501.422222222222,"1.75":2011.8324999999995,"2":2624.0888888888885,"2.25":3289.855138888889,"2.5":4014.005555555556,"2.75":4868.523194444444,"3":5846.636666666668},"6":{"0.75":478.9529166666667,"0.875":618.7757847222223,"1":803.9493333333332,"1.125":985.7499027777776,"1.25":1223.6305555555555,"1.375":1461.330513888889,"1.5":1757.742222222222,"1.75":2359.985666666666,"2":3076.2088888888884,"2.25":3861.1683888888892,"2.5":4718.588888888889,"2.75":5712.992277777777,"3":6845.750666666669},"7":{"0.75":543.8672916666667,"0.875":706.768045138889,"1":918.8186666666666,"1.125":1128.8785902777777,"1.25":1399.7763888888887,"1.375":1676.0374513888892,"1.5":2014.0622222222219,"1.75":2708.1388333333325,"2":3528.3288888888883,"2.25":4432.481638888889,"2.5":5423.172222222222,"2.75":6557.461361111111,"3":7844.864666666669},"8":{"0.75":608.7816666666668,"0.875":794.7603055555556,"1":1033.6879999999999,"1.125":1272.0072777777777,"1.25":1575.922222222222,"1.375":1890.7443888888893,"1.5":2270.382222222222,"1.75":3056.291999999999,"2":3980.448888888888,"2.25":5003.79488888889,"2.5":6127.7555555555555,"2.75":7401.930444444444,"3":8843.97866666667},"9":{"0.75":673.6960416666668,"0.875":882.7525659722223,"1":1148.5573333333332,"1.125":1415.1359652777778,"1.25":1752.0680555555552,"1.375":2105.4513263888894,"1.5":2526.702222222222,"1.75":3404.4451666666655,"2":4432.568888888888,"2.25":5575.10813888889,"2.5":6832.3388888888885,"2.75":8246.399527777778,"3":9843.09266666667},"10":{"0.75":738.6104166666669,"0.875":970.744826388889,"1":1263.4266666666665,"1.125":1558.2646527777779,"1.25":1928.2138888888885,"1.375":2320.1582638888895,"1.5":2783.0222222222224,"1.75":3752.598333333332,"2":4884.688888888888,"2.25":6146.42138888889,"2.5":7536.9222222222215,"2.75":9090.868611111111,"3":10842.206666666669},"11":{"0.75":803.5247916666669,"0.875":1058.7370868055557,"1":1378.2959999999998,"1.125":1701.393340277778,"1.25":2104.359722222222,"1.375":2534.8652013888895,"1.5":3039.3422222222225,"1.75":4100.7514999999985,"2":5336.808888888888,"2.25":6717.73463888889,"2.5":8241.505555555555,"2.75":9935.337694444444,"3":11841.320666666668},"12":{"0.75":868.439166666667,"0.875":1146.7293472222223,"1":1493.1653333333331,"1.125":1844.522027777778,"1.25":2280.5055555555555,"1.375":2749.5721388888896,"1.5":3295.6622222222227,"1.75":4448.904666666665,"2":5788.928888888888,"2.25":7289.04788888889,"2.5":8946.08888888889,"2.75":10779.806777777778,"3":12840.434666666668},"13":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":2456.651388888889,"1.375":2964.2790763888897,"1.5":3551.982222222223,"1.75":4797.057833333332,"2":6241.048888888888,"2.25":7860.36113888889,"2.5":9650.672222222223,"2.75":11624.275861111111,"3":13839.548666666667},"14":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":2632.7972222222224,"1.375":3178.98601388889,"1.5":3808.302222222223,"1.75":5145.210999999999,"2":6693.1688888888875,"2.25":8431.67438888889,"2.5":10355.255555555557,"2.75":12468.744944444445,"3":14838.662666666667},"15":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":3393.69295138889,"1.5":4064.622222222223,"1.75":5493.364166666666,"2":7145.288888888887,"2.25":9002.98763888889,"2.5":11059.838888888891,"2.75":13313.214027777778,"3":15837.776666666667},"16":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":3608.39988888889,"1.5":4320.942222222223,"1.75":5841.517333333333,"2":7597.408888888887,"2.25":9574.300888888889,"2.5":11764.422222222225,"2.75":14157.683111111111,"3":16836.890666666666},"17":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":4577.262222222223,"1.75":6189.6705,"2":8049.528888888887,"2.25":10145.614138888888,"2.5":12469.00555555556,"2.75":15002.152194444445,"3":17836.004666666668},"18":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":4833.582222222222,"1.75":6537.823666666667,"2":8501.648888888887,"2.25":10716.927388888887,"2.5":13173.588888888893,"2.75":15846.621277777778,"3":18835.11866666667},"19":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":5089.902222222222,"1.75":6885.976833333334,"2":8953.768888888888,"2.25":11288.240638888887,"2.5":13878.172222222227,"2.75":16691.09036111111,"3":19834.23266666667},"20":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":5346.222222222222,"1.75":7234.130000000001,"2":9405.888888888889,"2.25":11859.553888888886,"2.5":14582.755555555561,"2.75":17535.559444444443,"3":20833.34666666667},"21":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":null,"1.75":null,"2":9858.00888888889,"2.25":12430.867138888885,"2.5":15287.338888888895,"2.75":18380.028527777777,"3":21832.460666666673},"22":{"0.75":null,"0.875":null,"1":null,"1.125":null,"1.25":null,"1.375":null,"1.5":null,"1.75":null,"2":10310.12888888889,"2.25":13002.180388888884,"2.5":15991.922222222229,"2.75":19224.49761111111,"3":22831.574666666675}},"fit_prices":{"New Fit":{"0.75":51.0,"0.875":51.0,"1":51.0,"1.125":51.0,"1.25":55.0,"1.375":55.0,"1.5":63.0,"1.75":63.0,"2":69.0,"2.25":78.0,"2.5":78.0,"2.75":90.0,"3":97.0},"Customer-Supplied Fit":{"0.75":67.0,"0.875":67.0,"1":67.0,"1.125":67.0,"1.25":72.0,"1.375":72.0,"1.5":78.0,"1.75":78.0,"2":90.0,"2.25":101.0,"2.5":101.0,"2.75":117.0,"3":124.0},"Double Taper":{"0.75":85.0,"0.875":85.0,"1":85.0,"1.125":85.0,"1.25":104.0,"1.375":104.0,"1.5":121.0,"1.75":127.0,"2":173.0,"2.25":253.0,"2.5":276.0,"2.75":322.0,"3":391.0}}}}

    const materialEl = document.getElementById('material')
    const diameterEl = document.getElementById('diameter')
    const lengthEl = document.getElementById('length')
    const taperEl = document.getElementById('taper')
    const couplingEl = document.getElementById('coupling')

    const declineWarningEl = document.getElementById('declineWarning')

    const basePriceEl = document.getElementById('basePrice')
    const servicePriceEl = document.getElementById('servicePrice')
    const totalPriceEl = document.getElementById('totalPrice')
    const billableLengthEl = document.getElementById('billableLength')
    const selectedDiameterEl = document.getElementById('selectedDiameter')
    const selectedConfigEl = document.getElementById('selectedConfig')
    const calcStatusEl = document.getElementById('calcStatus')

    const customerNameEl = document.getElementById('customerName')
    const customerEmailEl = document.getElementById('customerEmail')
    const customerPhoneEl = document.getElementById('customerPhone')
    const customerNotesEl = document.getElementById('customerNotes')
    const emailStatusEl = document.getElementById('emailStatus')

    function currency(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value || 0)
    }

    function roundBillableFeet(lengthInches) {
      return Math.ceil(lengthInches / 12)
    }

    function setStatus(message, type) {
      if (!calcStatusEl) return
      calcStatusEl.textContent = message
      calcStatusEl.className = 'status ' + (type || '')
    }

    function clearStatus() {
      if (!calcStatusEl) return
      calcStatusEl.textContent = ''
      calcStatusEl.className = 'status'
    }

    function setEmailStatus(message, type) {
      if (!emailStatusEl) return
      emailStatusEl.textContent = message
      emailStatusEl.className = 'status ' + (type || '')
    }

    function clearEmailStatus() {
      if (!emailStatusEl) return
      emailStatusEl.textContent = ''
      emailStatusEl.className = 'status'
    }

    function updateWarning() {
      if (couplingEl.value === 'Decline') {
        declineWarningEl.classList.add('active')
      } else {
        declineWarningEl.classList.remove('active')
      }
    }

    function getAvailableDiameters(material) {
      const table = PRICING[material]
      return table.diameters.filter(diameter =>
        Object.values(table.length_prices).some(row => row[diameter] !== null)
      )
    }

    function getServiceRetail(table, diameter, taper, coupling) {
      const newFit = table.fit_prices['New Fit']?.[diameter] || 0
      const suppliedFit = table.fit_prices['Customer-Supplied Fit']?.[diameter] || 0
      const doubleTaper = table.fit_prices['Double Taper']?.[diameter] || 0

      let total = 0
      if (taper === 'Double Taper') {
        total += doubleTaper
      }
      if (coupling === 'New') {
        total += newFit
      } else if (coupling === 'Existing') {
        total += suppliedFit
      }
      return total
    }

    function populateMaterials() {
      materialEl.innerHTML = ''
      Object.keys(PRICING).forEach(material => {
        const option = document.createElement('option')
        option.value = material
        option.textContent = material
        materialEl.appendChild(option)
      })
    }

    function populateDiameters() {
      const material = materialEl.value
      const available = getAvailableDiameters(material)
      diameterEl.innerHTML = ''
      available.forEach(diameter => {
        const option = document.createElement('option')
        option.value = diameter
        option.textContent = `${parseFloat(diameter).toFixed(3)} in`
        diameterEl.appendChild(option)
      })
      if (available.includes('1')) {
        diameterEl.value = '1'
      }
    }

    function calculate() {
      clearStatus()
      updateWarning()

      const material = materialEl.value
      const diameter = diameterEl.value
      const taper = taperEl.value
      const coupling = couplingEl.value
      const length = Number(lengthEl.value)

      if (!length || length < 24 || length > 264) {
        setStatus('Enter a shaft length between 24 and 264 inches.', 'error')
        return
      }

      const billableFeet = roundBillableFeet(length)
      if (billableFeet < 2 || billableFeet > 22) {
        setStatus('The selected length falls outside the supported pricing range.', 'error')
        return
      }

      const table = PRICING[material]
      const shaftRetail = table.length_prices[String(billableFeet)]?.[diameter]

      if (shaftRetail === null || shaftRetail === undefined) {
        setStatus('This material, diameter, and length combination is not priced in the current matrix. Please adjust the selection or route to manual review.', 'error')
        return
      }

      const serviceRetail = getServiceRetail(table, diameter, taper, coupling)
      const total = shaftRetail + serviceRetail

      basePriceEl.textContent = currency(shaftRetail)
      servicePriceEl.textContent = currency(serviceRetail)
      totalPriceEl.textContent = currency(total)

      billableLengthEl.textContent = `${billableFeet} ft`
      selectedDiameterEl.textContent = `${parseFloat(diameter).toFixed(3)} in`
      selectedConfigEl.textContent = `${taper === 'Double Taper' ? 'Double' : 'Single'} / ${coupling}`

      let message = 'Price calculated successfully using standard matrix pricing with no discounts applied.'
      if (coupling === 'Decline') {
        message = 'Price calculated successfully. Coupling machining has been excluded and the decline warning has been applied.'
      }
      setStatus(message, 'success')
    }

    function resetForm() {
      materialEl.value = 'AQ17'
      populateDiameters()
      if ([...diameterEl.options].some(o => o.value === '1')) {
        diameterEl.value = '1'
      }
      lengthEl.value = 41
      taperEl.value = 'Single Taper'
      couplingEl.value = 'New'
      if (customerNameEl) customerNameEl.value = ''
      if (customerEmailEl) customerEmailEl.value = ''
      if (customerPhoneEl) customerPhoneEl.value = ''
      if (customerNotesEl) customerNotesEl.value = ''
      clearStatus()
      clearEmailStatus()
      calculate()
    }

    async function sendEmailQuote() {
      clearEmailStatus()

      const name = customerNameEl?.value?.trim() || ''
      const email = customerEmailEl?.value?.trim() || ''
      const phone = customerPhoneEl?.value?.trim() || ''
      const notes = customerNotesEl?.value?.trim() || ''

      if (!name) {
        setEmailStatus('Please enter your name.', 'error')
        return
      }
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setEmailStatus('Please enter a valid email address.', 'error')
        return
      }

      const material = materialEl.value
      const diameter = diameterEl.value
      const taper = taperEl.value
      const coupling = couplingEl.value
      const length = Number(lengthEl.value)
      const billableFeet = roundBillableFeet(length)
      const shaftRetail = PRICING[material].length_prices[String(billableFeet)]?.[diameter]
      const serviceRetail = getServiceRetail(PRICING[material], diameter, taper, coupling)
      const total = (shaftRetail || 0) + serviceRetail

      const templateParams = {
        email: EMAILJS_CONFIG.toEmail,
        to_email: EMAILJS_CONFIG.toEmail,
        from_name: name,
        reply_to: email,
        phone: phone || 'N/A',
        notes: notes || 'N/A',
        material_grade: material,
        shaft_diameter: `${parseFloat(diameter).toFixed(3)} in`,
        shaft_length: `${length} in`,
        billable_length: `${billableFeet} ft`,
        taper_config: taper,
        coupling_config: coupling,
        shaft_price: currency(shaftRetail),
        service_price: currency(serviceRetail),
        total_estimate: currency(total),
      }

      const btn = document.getElementById('emailQuoteBtn')
      const originalText = btn?.textContent || 'Email Quote Request'
      if (btn) {
        btn.disabled = true
        btn.textContent = 'Sending...'
      }

      try {
        await emailjs.send(
          EMAILJS_CONFIG.serviceId,
          EMAILJS_CONFIG.templateId,
          templateParams,
          { publicKey: EMAILJS_CONFIG.publicKey }
        )
        setEmailStatus('Quote request sent successfully. Our team will follow up with you shortly.', 'success')
        if (customerNameEl) customerNameEl.value = ''
        if (customerEmailEl) customerEmailEl.value = ''
        if (customerPhoneEl) customerPhoneEl.value = ''
        if (customerNotesEl) customerNotesEl.value = ''
      } catch (err) {
        setEmailStatus('Failed to send quote request. Please try again or contact us directly.', 'error')
        console.error('EmailJS error:', err)
      } finally {
        if (btn) {
          btn.disabled = false
          btn.textContent = originalText
        }
      }
    }

    materialEl.addEventListener('change', () => {
      populateDiameters()
      calculate()
    })
    diameterEl.addEventListener('change', calculate)
    lengthEl.addEventListener('input', calculate)
    taperEl.addEventListener('change', calculate)
    couplingEl.addEventListener('change', calculate)
    document.getElementById('calculateBtn').addEventListener('click', calculate)
    document.getElementById('resetBtn').addEventListener('click', resetForm)
    document.getElementById('emailQuoteBtn').addEventListener('click', sendEmailQuote)

    populateMaterials()
    materialEl.value = 'AQ17'
    populateDiameters()
    couplingEl.value = 'New'
    calculate()
  }

  render() {
    return (
      <div
        id="shaft-price-estimator"
        className="shaft-estimator-wrapper"
        dangerouslySetInnerHTML={{ __html: SHAFT_HTML }}
      />
    )
  }
}

export default ShaftPriceEstimator
